import { render } from "./FormInvestment.vue?vue&type=template&id=36a598f6"
import script from "./FormInvestment.vue?vue&type=script&lang=js"
export * from "./FormInvestment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__